import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';
import { router } from '@/routes/router';
import { ToastProvider } from '@/components/ui/ToastProvider';

export default function App() {
  // Icon stroke and sizing live in styles/globals.css, matching the player
  // app so the two surfaces read as one product.
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastProvider />
    </QueryClientProvider>
  );
}
